export default "__VITE_PUBLIC_ASSET__ba77658f__"